module.exports = __webpack_public_path__ + "img/2-classes-table.ddcf7d9c.svg";